import { CustomEdgeType } from "@uikit/util/CustomEdgeUtil";
import { useSignal } from "@preact/signals-react";
import { useCallback, useMemo, useRef } from "react";
import useStateRef from "react-usestateref";
import { Node, useNodesInitialized } from "reactflow";

function deepDeps(value: any) {
  if (typeof value === "object") {
    return JSON.stringify(value);
  }
  return value;
}

/**
 * ReactFlow 组件相关状态
 *
 * 将状态抽离 container, 方便后续将状态扩展为 useSignal
 *
 */
export function useHomeReactFlowState() {
  const nodeIndexRef = useRef(1);
  const edgeIndexRef = useRef(0);
  const isNewEdgeRunRef = useRef(false);

  const [nodes, setNodes, nodesRef] = useStateRef<Node<any>[]>([]);
  const [edges, setEdges, edgesRef] = useStateRef<CustomEdgeType[]>([]);
  const [selectedUI, setSelectedUI, selectedUIRef] = useStateRef("");
  /**
   * 每个节点渲染完成的状态
   */
  const nodeRenderUpdated = useNodesInitialized();

  /**
   * 切换项目后 所有节点挂载完成状态
   */
  const nodeProjectMounted = useSignal(false);

  const getNodes = useCallback(() => nodesRef.current, []);
  const getEdges = useCallback(() => edgesRef.current, []);

  // FIXME: 深度状态需要防止改变状态相同时,但状态未变导致循环渲染
  // 解决方案:
  // 1. 变成 string 对比
  // 2. 重写 react-usestateref 让其具备重复状态不更新的情况
  // 3. 解决监听状态导致的重复渲染问题
  const nodesState = useMemo(() => ({ nodes, setNodes, nodesRef, getNodes }), [deepDeps(nodes)]);
  const edgesState = useMemo(() => ({ edges, setEdges, edgesRef, getEdges }), [deepDeps(edges)]);

  return {
    nodesState,
    edgesState,
    nodeRenderUpdated,
    nodeProjectMounted,

    nodeIndexRef,
    edgeIndexRef,
    isNewEdgeRunRef,

    selectedUI,
    setSelectedUI,
    selectedUIRef,
  };
}
